<template>
  <div class="home">
    <section class="header">
      <img :src="brand" class="brand" alt />
      <div class="menus" v-if="!isMobile">
        <el-popover
          popper-class="popover"
          placement="bottom"
          trigger="manual"
          v-model="visible"
          style="padding: 0"
        >
          <el-card>
            <div class="popover-desc">
              <h2>
                {{ activeUser.details.nama }}
              </h2>
              <small>( {{ activeUser.data.tlc }} )</small>
            </div>
            <ul class="popover-list">
              <li @click="(modal.account = true), (visible = false)">
                <i class="el-icon-s-tools"></i> Account Setting
              </li>
              <li @click="$router.push({ name: 'Delegation' })">
                <i class="el-icon-link"></i> Delegation
              </li>
              <li @click="viewNDA">
                <i :class="loading.viewNDA ? 'el-icon-loading': 'el-icon-postcard'"></i> Doc.NDA 
              </li>
              <li v-if="dataRCForm.data.length>0" @click="handleSelect('rc'), (visible = false)">
                <i :class="'el-icon-s-custom'"></i><span>Service Rating</span>
              </li>
              <li
                v-if="activeUser.data.divisi == 'Desain Kreatif'"
                @click="(modal.background = true), (visible = false)"
              >
                <i class="el-icon-picture"></i>
                Background
              </li>
              <li v-if="activeUser.data.se">
                <span><i class="el-icon-lock"></i> Script Enginer</span>
                <div>
                  <el-input v-model="modal.se"></el-input>
                  <div id="lbl_result_se"></div>
                  <el-button
                    @click="handleSE"
                    type="success"
                    size="small"
                    icon="el-icon-unlock"
                    style="width: 100%;"
                  ></el-button>
                </div>
              </li>
            </ul>
          </el-card>

          <div slot="reference" class="users" @click="handleFoto">
            <el-avatar
              shape="square"
              size="medium"
              :src="activeUser.foto"
            ></el-avatar>
          </div>
        </el-popover>

        <el-popover
          popper-class="popover"
          placement="bottom"
          trigger="manual"
          v-model="appSlot"
          style="padding: 0"
        >
          <el-card>
            <ul
              v-for="item in listApps"
              :key="item.id"
              class="popover-listapps"
            >
              <li @click="handleUrlApps(item), (appSlot = false)">
                <div class="url-list">
                  <img
                    class="brand-apps"
                    :src="require('@/assets/logo/apps/' + item.logo)"
                    alt
                  />
                  <span>{{ item.app_ext_nm }}</span>
                </div>
              </li>
            </ul>
          </el-card>

          <div slot="reference" class="users" @click="appSlot = !appSlot">
            <el-button
              v-if="!isTopManagement"
              @click="handleListApps"
              type="primary"
              size="medium"
              icon="el-icon-s-grid"
              >Apps</el-button
            >
          </div>
        </el-popover>

        <el-button
          @click="handleUrlAppsIn('CorporateGov')"
          type="primary"
          size="medium"
          icon="el-icon-document"
          style="background: #f59300;border-color: #f59300;margin-left:0px!important"
          v-if="!isTopManagement"
        >
          <!-- <img :src="require('@/assets/logo/apps/guide.png')" style="width: 20px;" alt /> -->
          <!-- Corporate Governance -->
          Docs
        </el-button>

        <el-button
          @click="handleSignout"
          type="danger"
          size="medium"
          icon="el-icon-switch-button"
          style="margin-left: 0px!important;"
        ></el-button>
      </div>
      <div v-else style="display:flex;">
        <el-button
          @click="handleUrlAppsIn('CorporateGov')"
          type="primary"
          size="medium"
          style="padding: 0px 0px!important;background-color: #1b355000!important;border-color:#409eff00"
        >
          <img
            :src="require('@/assets/logo/apps/guide.png')"
            style="width: 13px;"
            alt
          />
          <!-- Corporate Governance -->
        </el-button>
        <el-popover
          popper-class="popover"
          placement="bottom"
          trigger="manual"
          v-model="appSlot"
          style="padding: 0"
        >
          <el-card>
            <ul
              v-for="item in listApps"
              :key="item.id"
              class="popover-listapps"
            >
              <li @click="handleUrlApps(item), (appSlot = false)">
                <div class="url-list">
                  <img
                    class="brand-apps"
                    :src="require('@/assets/logo/apps/' + item.logo)"
                    alt
                  />
                  <span>{{ item.app_ext_nm }}</span>
                </div>
              </li>
            </ul>
          </el-card>

          <el-button
            slot="reference"
            @click="appSlot = !appSlot"
            class="color-light m-menu-padding"
            size="medium"
            type="text"
            icon="el-icon-s-grid"
          ></el-button>
        </el-popover>
        <el-popover
          popper-class="popover"
          placement="bottom"
          trigger="manual"
          v-model="visible"
          style="padding: 0"
        >
          <el-menu
            @select="handleSelect"
            class="el-menu-vertical-demo m-menu-padding"
            index="main"
          >
            <el-submenu index="main-sub">
              <template slot="title"><i class="el-icon-user"></i><span style="margin-right:50px">User Profile</span></template>
              <el-menu-item index="userprofile">
                <i class="el-icon-setting"></i>
                <span>Account Setting</span>
              </el-menu-item>
              <el-menu-item index="nda">
                <i :class="loading.viewNDA ? 'el-icon-loading': 'el-icon-postcard'"></i><span>Doc.NDA</span>
              </el-menu-item>
              <el-menu-item index="rc" v-if="dataRCForm.data.length>0">
                <i :class="'el-icon-s-custom'"></i><span>Service Rating</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="signout">
              <i class="el-icon-switch-button"></i>
              <span>Sign Out</span>
            </el-menu-item>
          </el-menu>

          <div slot="reference" class="users" @click="visible = !visible">
            <el-button
              class="color-light"
              size="medium"
              type="text"
              icon="el-icon-user-solid"
            ></el-button>
          </div>
        </el-popover>
      </div>
    </section>
    <section class="content">
      <div v-if="isMobile" class="profile">
        <img class="profile-photo" :src="activeUser.foto" alt="profile" />
        <h2>{{ activeUser.details.nama }}</h2>
        <small>{{ activeUser.data.tlc }}</small>
      </div>
      <ul class="grid-row">
        <template v-for="(item, index) in aplikasi">
          <li
            :key="index"
            @click="
              accessAllowed(item.title)
                ? handleApp(item.title.toLowerCase())
                : clickedDisabled()
            "
            :class="accessAllowed(item.title) || (item.title=='CUENTA' && !isTopManagement) ? 'card' : (isTopManagement ? 'card-hidden' : 'card-hidden')"
          >
          <!-- :class="accessAllowed(item.title) ? 'card' : (isTopManagement ? 'card-hidden' : 'card-hidden')" -->
            <el-tag
              class="notif"
              type="danger"
              size="small"
              v-if="item.title == 'SIMFONI' || item.title == 'HARMONI' || item.title == 'KANALA' || item.title == 'COMMISIONER DASHBOARD' || item.title == 'CUENTA'"
            >
              <i :class="item.title == 'COMMISIONER DASHBOARD' ? 'el-icon-s-comment' : 'el-icon-message-solid'"></i>
              {{
                item.title == "SIMFONI"
                  ? getSimfoni
                  : item.title == "HARMONI"
                  ? getHarmoni
                  : item.title == "KANALA"
                  ? getKanala
                  : item.title == "COMMISIONER DASHBOARD"
                  ? getCommDash
                  : item.title == "CUENTA"
                  ? getCuenta
                  : ""
              }}
            </el-tag>
            <img class="brand-card" :src="item.brand" alt />
            <h3 class="title">{{ item.title }}</h3>
          </li>
        </template>
      </ul>
    </section>
    <el-dialog
      v-if="!isMobile"
      :modalAppendToBody="false"
      width="450px"
      :visible.sync="modal.account"
      :close-on-click-modal="false"
    >
      <span slot="title"><i class="el-icon-s-tools"></i> Account Setting</span>
      <Profile />
    </el-dialog>
    <el-dialog
      v-if="!isMobile"
      :modalAppendToBody="false"
      width="1300px"
      top="50px"
      :visible.sync="modal.background"
      :close-on-click-modal="false"
      custom-class="paddingless"
    >
      <span slot="title"><i class="el-icon-s-custom"></i> Background</span>
      <Background :background="background" :bgList="bglist" />
    </el-dialog>
    <el-dialog
      width="95%"
      title="Attendance by GPS"
      :visible.sync="attendance.dialogVisible"
      :before-close="handleAbsenShorcutClose"
      :close-on-click-modal="false"
      :modalAppendToBody="false"
      custom-class="paddingless"
      top="30vh"
      >
      <div style="padding:1.2rem">
        <span>Description</span>
        <el-input type="textarea" v-model="attendance.form.desc"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAttendance" :disabled="attendance.loading">Cancel</el-button>
        <el-button type="primary" @click="sendAttendance" :loading="attendance.loading">Submit</el-button>
      </span>
    </el-dialog>
    <el-drawer
      v-if="isMobile"
      class="drawer"
      size="75%"
      direction="btt"
      :visible.sync="modal.account"
      :modalAppendToBody="false"
    >
      <span slot="title"><i class="el-icon-s-tools"></i> Account Settting</span>
      <Profile />
    </el-drawer>
    <div id="hmoveable" v-if="isMobile">
      <!-- Include a header DIV with the same name as the draggable DIV, followed by "header" -->
      <div id="bodymoveable" v-if="attendance.showShorcut" style="background-color: #2e3755;">
        <!-- <el-button type="success" class="b-moveable" round @click="handleAbsenShorcut">
          <i class="el-icon-camera"></i>
        </el-button> -->
        <i class="el-icon-close" @click="handleCloseShorcutAbsen" style="padding:0px 10px 0px 0px; background: none!important;"></i>
        <!-- <div style="text-align: center;width: 100%;">
          <i class="el-icon-watch" @click="handleCloseShorcutAbsen"></i>&nbsp;
          <span>DAILY ATTENDANCE</span>
        </div> -->
        <el-button type="info" size="small" @click="handleAbsenShorcut" class="btn-tag" :style="restrictedTime?'color:#ffffff2e':''" :disabled="restrictedTime">
          <i class="el-icon-watch"></i>
          <span>DAILY ATTENDANCE</span>
          <small style="color: darkseagreen;margin-left:10px"><i>{{ attendance.latestOn }}</i></small>
        </el-button>
      </div>
    </div>
    <rcForm :visible="visibleRCForm" :params="dataRCForm" :restrictedTime="!restrictedTime"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Profile from "@/components/Profile.vue";
import Background from "@/components/background/Background.vue";
import CryptoJS from "crypto-js";
import _ from "lodash";
import axios from "axios";
import { TweenLite, gsap } from "gsap";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjsRelativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/advancedFormat";
import rcForm from "@/views/Home/Rc.vue";

const moment = dayjs;
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(dayjsRelativeTime);
dayjs.extend(advancedFormat);
const dttz = dayjs.tz.guess()

export default {
  name: "Home",
  components: {
    Profile,
    Background,
    rcForm
  },
  data() {
    const aplikasi = [
      {
        id: 1,
        title: "SIMFONI",
        brand: require("@/assets/logo/simfoni/simfoni-icon.png"),
      },
      {
        id: 2,
        title: "HARMONI",
        brand: require("@/assets/logo/harmoni/harmoni-icon.png"),
      },
      {
        id: 3,
        title: "ASSIST",
        brand: require("@/assets/logo/assist/assist-icon.png"),
      },
      {
        id: 4,
        title: "INFINITY",
        brand: require("@/assets/logo/infinity/infinity-icon.png"),
      },
      {
        id: 5,
        title: "KANALA",
        brand: require("@/assets/logo/kanala/kanala-icon.png"),
      },
      {
        id: 7,
        title: "IDEAPP",
        brand: require("@/assets/logo/idea/idea-icon.png"),
      },
      {
        id: 8,
        title: "CUENTA",
        brand: require("@/assets/logo/accounting/CuentaLogoOnlyMain.png"),
      },
      {
        id: 9,
        title: "EXECUTIVE SUMMARY",
        brand: require("@/assets/logo/accounting/CuentaLogoOnlyMain.png"),
      },
      {
        id: 10,
        title: "COMMISIONER DASHBOARD",
        brand: require("@/assets/logo/accounting/CuentaLogoOnlyMain.png"),
      },
    ];
    return {
      moment,
      loading:{
        viewNDA: false
      },
      dttz,
      activeIndex: "",
      visible: false,
      appSlot: false,
      url: process.env.VUE_APP_BACKEND,
      modal: {
        se:null,
        account: false,
        background: false,
      },
      aplikasi,
      attendance: {
        latestOn: "",
        showShorcut: true,
        dialogVisible: false,
        pollingGPS: null,
        loading: false,
        form: {
          desc: null,
          coordinate: {
            latitude: 0,
            longitude: 0
          }
        }
      },
      visibleRCForm: false,
      dataRCForm: {
        data: []
      }
    };
  },
  watch: {
    getPrivate() {
      let type = "";
      if (this.getPrivate.type == "sim") {
        type = "Simfoni";
        this.$store.dispatch("FetchSimfoniNotif");
      } else if (this.getPrivate.type == "hrm") {
        type = "Harmoni";
        this.$store.dispatch("FetchHarmoniNotif");
      } else if (this.getPrivate.type == "knl") {
        type = "Kanale";
        this.$store.dispatch("FetchKanalaNotif");
      } else if (this.getPrivate.type == "das") {
        this.$notify.info({
          title: `Notification!`,
          message: this.getPrivate.message,
        });
      } else if (this.getPrivate.type == "qnt") {
        type = "Cuenta";
        this.$store.dispatch("FetchCuentaNotif");
      }

      if (
        this.getPrivate.message.aksi === 2 ||
        this.getPrivate.message.aksi === 1
      ) {
        this.$notify.info({
          title: `Notification ${type} `,
          message: `New notification from ${this.getPrivate.message.tlc_from}!`,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      activeUser: "getActiveUser",
      getPrivate: "GET_PRIVATE",
      getUser: "GET_USERS",
      background: "getBackground",
      getSimfoni: "Get_Simfoni",
      getHarmoni: "Get_Harmoni",
      getKanala: "Get_Kanala",
      getCommDash: "Get_CommDash",
      getCuenta: "Get_Cuenta",
      bglist: "getbg",
      listApps: "getListApps",
    }),
    hakAksesIdeapp() {
      let akses = false;
      if (this.activeUser) {
        if (
          this.activeUser.data.departement == "Infrastructure & Implementer" ||
          this.activeUser.data.tlc == "WBS"
        ) {
          akses = true;
        }
      }

      return akses;
    },
    hakAksesMandala() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "ma") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesSimfoni() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "si") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesHarmoni() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "ha") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesAssist() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "as") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesInfinity() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "in") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesKanala() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "ka") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesIdeapp() {
      let akses = false;
      if (this.activeUser) {
        if (
          this.activeUser.data.divisi &&
          this.activeUser.data.divisi.toLowerCase().includes("infrastructure")
        )
          akses = true;
      }

      return akses;
    },
    hakAksesAccounting() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "ac") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesEIS() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "es") {
            akses = true;
          }
        });
      }

      return akses;
    },
    hakAksesComDash() {
      let akses = false;
      if (this.activeUser) {
        let hak = this.activeUser.data.hak_akses.split(",");
        _.forEach(hak, function(value) {
          if (value == "cs") {
            akses = true;
          }
        });
      }

      return akses;
    },
    brand() {
      if (this.isMobile) {
        return require("@/assets/logo/pandapakita/pandapakita-light.png");
      } else {
        return require("@/assets/logo/pandapakita/pandapakita-logo.png");
      }
    },
    isTopManagement(){
      return this.activeUser.data.posisi == "Komisaris"
    },
	restrictedTime(){
      return !((parseInt(this.moment().format('HH'))>=7 && parseInt(this.moment().format('HH'))<=7) || 
      (parseInt(this.moment().format('HH'))==17 && parseInt(this.moment().format('mm'))<=30))
    }
  },
  created() {
    this.$store.dispatch("getbgList", this.activeUser);
  },
  methods: {
    startAnimation() {
      gsap.from(".content", {
        y: -10,
        duration: 3,
        ease: "elastic",
      });
    },
    async openCache() {
      return new Promise((resolve, reject) => {
        let request = window.indexedDB.open(
          process.vue.VUE_APP_LOCAL_DB,
          process.vue.VUE_APP_LOCAL_DB_VERSION
        );

        request.onerror = (e) => {
          console.log("Error opening cache db", e);
          reject("Error");
        };

        request.onsuccess = (e) => {
          resolve(e.target.result);
        };

        request.onupgradeneeded = (e) => {
          let cacheDB = e.target.result;
          let objectStore = cacheDB.createObjectStore("home", {
            autoIncrement: true,
            keyPath: "id",
          });
        };
      });
    },
    sendSocketEvent() {
      this.$store.dispatch("SEND_EVENT", {
        type: "simfoniConnected",
        data: {
          tlc: this.activeUser.data.tlc,
          api: this.activeUser.key,
          password: this.activeUser.data.password,
          divisi: this.activeUser.data.divisi,
        },
        socketType: "sim",
      });

      this.$store.dispatch("SEND_EVENT", {
        type: "harmoniConnected",
        data: {
          tlc: this.activeUser.data.tlc,
        },
        socketType: "hrm",
      });

      this.$store.dispatch("SEND_EVENT", {
        type: "kanalaConnected",
        data: {
          tlc: this.activeUser.data.tlc,
          api: this.activeUser.key,
          password: this.activeUser.data.password,
          divisi: this.activeUser.data.divisi,
        },
        socketType: "knl",
      });
    },
    handleFoto() {
      //normalisasi pop up
      this.appSlot = false;

      this.visible = !this.visible;
    },
    handleListApps() {
      //normalisasi pop up
      this.visible = false;
    },
    handleSignout() {
      const token = JSON.parse(localStorage.getItem("token"));
      this.$store.dispatch("setLogOutSSO", {
        token : token.ruid_sso
      })
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
    randomString() {
      const characters =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const charactersLength = characters.length;
      const length = 30;
      let randomString = "";
      for (let i = 0; i < length; i++) {
        randomString += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      return randomString;
    },
    base64Encrypt(string) {
      const encodedWord = CryptoJS.enc.Utf8.parse(string);
      const encoded = CryptoJS.enc.Base64.stringify(encodedWord);

      return encoded;
    },
    async loginApp(app) {
      let data;
      let url = "";
      if (app == "simfoni") {
        url = process.env.VUE_APP_SIMFONI + "login";
      } else if (app == "harmoni") {
        url = process.env.VUE_APP_HARMONI + "login";
      } else if (app == "mandala") {
        url = process.env.VUE_APP_MANDALA + "login";
      } else if (app == "cuenta") {
        url = process.env.VUE_APP_ACCOUNTING + "api/login";
      } else if (app == "ideapp") {
        url = process.env.VUE_APP_IDEAPP + "createtoken";
      } else if (app == "eis") {
        url = process.env.VUE_APP_EIS + "login";
      } else if (app == "comdash") {
        url = process.env.VUE_APP_EIS + "login";
      } else if (app == "kanala"){
        url = process.env.VUE_APP_KANALA + "api/login";
      } else if (app == "kanalaold"){
        url = process.env.VUE_APP_KANALAOLD + "api/login";
      }
      
      await axios({
        method: "post",
        url: url,
        data: {
          tlc: this.activeUser.data.tlc,
          password: this.activeUser.data.password,
        },
      })
        .then((response) => {
          data = response;
        })
        .catch((error) => {
          // window.open(process.env.VUE_APP_IDEAPP);
          data = error;
        });

      return data;
    },
    handleApp(type, action) {
      // if(this.visibleRCForm){
      //   this.$notify.warning({
      //     title: "Warning",
      //     message: 'please complete the RC essay first!'
      //   });
      // }else{
        if (type == "assist") {
          const encrypt = this.base64Encrypt(this.activeUser.data.tlc);
          const url = `${
            process.env.VUE_APP_INVENTORY_PATH
          }/login/login_proses/${this.randomString()}/${encrypt}`;
          window.location.href = url;
        } else if (type == "simfoni") {
          this.loginApp("simfoni").then((res) => {
            const wordArray = CryptoJS.enc.Utf8.parse(res.data.message);
            const base64 = CryptoJS.enc.Base64.stringify(wordArray);
            const random = this.randomString();
            const enc = window.btoa(JSON.stringify(res.data));
            window.location.href =
              process.env.VUE_APP_SIMFONI_PATH + //401 expired
              "/login/" +
              random.toString() +
              "/" +
              enc;
          });
        } else if (type == "harmoni") {
          this.loginApp("harmoni").then((res) => {
            const wordArray = CryptoJS.enc.Utf8.parse(res.data.message);
            const base64 = CryptoJS.enc.Base64.stringify(wordArray);
            const random = this.randomString();
            const enc = window.btoa(JSON.stringify(res.data));
            window.location.href =
              process.env.VUE_APP_HARMONI_PATH +
              "/login/" +
              random.toString() +
              "/" +
              enc;
          });
        } else if (type == "mandala") {
          this.loginApp("mandala").then((res) => {
            const wordArray = CryptoJS.enc.Utf8.parse(res.data.message);
            const base64 = CryptoJS.enc.Base64.stringify(wordArray);
            const random = this.randomString();
            const enc = window.btoa(JSON.stringify(res.data));
            window.location.href =
              process.env.VUE_APP_MANDALA_PATH +
              "/login/" +
              random.toString() +
              "/" +
              enc;
          });
        } else if (type == "infinity") {
          window.location.href = `${process.env.VUE_APP_INFINITY_PATH}/infocomm?id=${this.activeUser.data.tlc}`;
        } else if (type == "kanala") {
          // window.location.href = `${process.env.VUE_APP_KANALA_PATH}/core/session.php?q=${this.activeUser.data.tlc}`;
          this.loginApp("kanala").then((res) => {
            const aesKey = CryptoJS.enc.Utf8.parse("#Inf0glob4l_");
            const aesIv = CryptoJS.enc.Utf8.parse("0123456789jihgfedcba");
            const aesOptions = {
              iv: aesIv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7,
            };

            const plaindata = JSON.stringify({
              token: res.data.data.token,
              foto: this.activeUser.foto,
              tlc: this.activeUser.data.tlc,
              theme: this.activeUser.data.theme,
              departement: this.activeUser.data.departement,
              divisi: this.activeUser.data.divisi,
              nama_bidang: this.activeUser.data.nama_bidang,
              posisi: this.activeUser.data.posisi
            });

            const cipherdata = CryptoJS.AES.encrypt(
              plaindata,
              aesKey,
              aesOptions
            ).ciphertext.toString();
            const enc = CryptoJS.enc.Hex.parse(cipherdata);

            window.location.href = process.env.VUE_APP_KANALA_PATH + "login/" + enc;

          })
        } else if (type == "kanalaold") {
          // console.log(`${process.env.VUE_APP_KANALA_PATHOLD}/core/session.php?q=${this.activeUser.data.tlc}`)
          window.location.href = `${process.env.VUE_APP_KANALA_PATHOLD}/core/session.php?q=${this.activeUser.data.tlc}`;
        } else if (type == "ideapp") {
          // console.log("IdeApp");
          this.loginApp("ideapp").then((res) => {
            // console.log(res.data);
            const random = res.data.data;
            const userid = res.data.userid;
            window.location.href =
              process.env.VUE_APP_IDEAPP_PATH +
              "/login-mis/" +
              random +
              "/" +
              userid;
          });
        } else if (type == "cuenta") {
          this.loginApp("cuenta").then((res) => {
            const aesKey = CryptoJS.enc.Utf8.parse("#Inf0glob4l_");
            const aesIv = CryptoJS.enc.Utf8.parse("0123456789jihgfedcba");
            const aesOptions = {
              iv: aesIv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7,
            };

            const plaindata = JSON.stringify({
              token: res.data.data.token,
              foto: this.activeUser.foto,
              tlc: this.activeUser.data.tlc,
              theme: this.activeUser.data.theme,
              departement: this.activeUser.data.departement,
              divisi: this.activeUser.data.divisi,
              nama_bidang: this.activeUser.data.nama_bidang,
              posisi: this.activeUser.data.posisi
            });

            const cipherdata = CryptoJS.AES.encrypt(
              plaindata,
              aesKey,
              aesOptions
            ).ciphertext.toString();
            const enc = CryptoJS.enc.Hex.parse(cipherdata);

            window.location.href = process.env.VUE_APP_ACCOUNTING_PATH + "login/" + enc;
          });
        } else if (type == "executive summary") {
          this.loginApp("eis").then((res) => {
            const datatokens = {
              token: res.data.token,
              type: "es"
            }
            const b64 = CryptoJS.AES.encrypt(JSON.stringify(datatokens), 'encryptKeyDes').toString();
            const e64 = CryptoJS.enc.Base64.parse(b64);
            const tokenEncrypted = e64.toString(CryptoJS.enc.Hex);
            window.location.href =
              process.env.VUE_APP_EIS_PATH + "/login/" + tokenEncrypted;
          });
        } else if (type == "commisioner dashboard") {
          this.loginApp("comdash").then((res) => {
            const datatokens = {
              token: res.data.token,
              type: "cs"
            }
            const b64 = CryptoJS.AES.encrypt(JSON.stringify(datatokens), 'encryptKeyDes').toString();
            const e64 = CryptoJS.enc.Base64.parse(b64);
            const tokenEncrypted = e64.toString(CryptoJS.enc.Hex);
            window.location.href =
              process.env.VUE_APP_EIS_PATH + "/login/" + tokenEncrypted;
          });
        }
      // }
    },
    handleSelect(key, keyPath) {
      // console.log(key)
      if (key == "signout") {
        this.$router.push("/login");
      } else if (key == "settings") {
        this.$router.push({ name: "Background" });
        this.visible = false;
      } else if (key == "userprofile") {
        this.visible = false;
        this.modal.account = true;
      } else if (key == "nda") {
        this.viewNDA();
      } else if(key == "rc"){
        this.visibleRCForm = true
      }
    },
    async handleUrlApps(item) {
      // if(item.app_ext_id=='202209211307'){ // Dev GitLab
      //   this.$router.push({ name: "SSO", params: {id:item.app_ext_id}})
      // } else if(item.app_ext_id=='202209211310'){ // Mail
      //   this.$router.push({ name: "SSO", params: {id:item.app_ext_id}})
      // } else {
        window.open(item.link_url);
      // }
    },
    handleUrlAppsIn(route) {
      this.$router.push({ name: route });
    },
    accessAllowed(title) {
      if (title == "SIMFONI" && this.hakAksesSimfoni) {
        return true;
      } else if (title == "HARMONI" && this.hakAksesHarmoni) {
        return true;
      } else if (title == "ASSIST" && this.hakAksesAssist) {
        return true;
      } else if (title == "MANDALA" && this.hakAksesMandala) {
        return true;
      } else if (title == "INFINITY" && this.hakAksesInfinity) {
        return true;
      } else if (title == "KANALA" && this.hakAksesKanala) {
        return true;
      } else if (title == "KANALAOLD" && this.hakAksesKanala) {
        return true;
      } else if (title == "IDEAPP" && this.hakAksesIdeapp) {
        return true;
      } else if (title == "CUENTA" && this.hakAksesAccounting) {
        return true;
      } else if (title == "EXECUTIVE SUMMARY" && this.hakAksesEIS) {
        return true;
      } else if (title == "COMMISIONER DASHBOARD" && this.hakAksesComDash) {
        return true;
      }
      return false;
    },
    clickedDisabled() {
      this.$notify.warning({
        title: `Notification`,
        message: `You are not allowed!`,
      });
    },
    handleCloseShorcutAbsen(){
      this.attendance.showShorcut = false;
    },
    handleAbsenShorcut(){
      this.attendance.dialogVisible = true
    },
    handleAbsenShorcutClose(){
      this.attendance.dialogVisible = false
    },
    StartGPS() {
      if (navigator.geolocation && this.isMobile) {
        let a = null
        this.attendance.pollingGPS = setInterval(() => {
          navigator.geolocation.getCurrentPosition((position) => {
            a = position
            this.attendance.form.coordinate.latitude = position.coords.latitude;
            this.attendance.form.coordinate.longitude = position.coords.longitude;
          });

          if(a){
            clearInterval(this.attendance.pollingGPS)
          }
        }, 2000);
      }
    },
    getAttendance(){
      const storage = JSON.parse(localStorage.getItem("token"));
      axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/presensi",
          processData: false,
          auth: {
            username: this.activeUser.data.tlc,
            password: this.activeUser.data.password
          },
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
          params: {}
        })
        .then((response) => {
          if(response.data.data)
            this.getlatestOn(response.data.data.timestamp);
        })
    },
    async getRCList(){
      const storage = JSON.parse(localStorage.getItem("token"));
      await axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/serviceRating",
          processData: false,
          auth: {
            username: this.activeUser.data.tlc,
            password: this.activeUser.data.password
          },
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
          params: {}
        })
        .then((response) => {
          if(response.data.data)
            this.dataRCForm = {
              data: response.data.data,
            };
          this.visibleRCForm = this.dataRCForm.data.length>0
        })
    },
    sendAttendance(){
      //renew GPS coordinate
      navigator.geolocation.getCurrentPosition((position) => {
        this.attendance.form.coordinate.latitude = position.coords.latitude;
        this.attendance.form.coordinate.longitude = position.coords.longitude;
      });

      if (this.attendance.form.coordinate.longitude == 0 && this.attendance.form.coordinate.latitude == 0) {
        this.$notify({
          type:"warning",
          title: "Warning",
          message: "GPS Coordinate is Wrong, Please check whether GPS is active!"
        });
      } else if (this.attendance.form.desc == null || this.attendance.form.desc == undefined) {
        this.$notify({
          type:"warning",
          title: "Warning",
          message: "Description Can't be Empty!"
        });
      } else {
        this.attendance.loading = true;
        const storage = JSON.parse(localStorage.getItem("token"));
        
        axios({
          method: "post",
          url: process.env.VUE_APP_BACKEND + "api/presensi",
          processData: false,
          auth: {
            username: this.activeUser.data.tlc,
            password: this.activeUser.data.password
          },
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
          data: {
            tlc: this.activeUser.data.tlc,
            longitude: this.attendance.form.coordinate.longitude,
            latitude: this.attendance.form.coordinate.latitude,
            device: navigator.userAgent,
            description: this.attendance.form.desc,
            utc: this.dttz
          }
        })
        .then((response) => {
          this.attendance.loading = false;
          this.attendance.dialogVisible = false
          this.attendance.form.desc = null
          this.getlatestOn(response.data.data.timestamp);
          this.$notify({
            type:"success",
            title: "Success",
            message: "Attendance has been saved!"
          });
        })
        .catch(err => {
          this.attendance.loading = false;
          console.log(err);
          if (err.response.data.message === false) {
            this.$notify.error({
              title: "Error",
              message: err.response.data.message
            });
          } else {
            let responses = Object.assign({}, err.response);
            this.$notify.error({
              title: "Error",
              message: responses
            });
          }
          // this.$router.go();
        });
      }
    },
    cancelAttendance(){
      this.attendance.dialogVisible = false
      this.attendance.form.desc = null
    },
    getlatestOn(val){
      this.attendance.latestOn = "latest on " + this.moment(val,"YYYY-MM-DD HH:mm:ss").format("HH:mm")
    },
    async checkSessionSSO(){
      const token = JSON.parse(localStorage.getItem("token"))
      await this.$store.dispatch("getSessionSSOIsActive", {
        tlc: this.activeUser.data.tlc,
        token: token.uid_sso,
      }).then((res)=>{
      }).catch(()=>{
        localStorage.removeItem("token");
        this.$notify({
          type:"warning",
          title: "Warning",
          message: "Session of Single Sign On (SSO) is Expired!"
        });
        this.$router.go();
      })
    },
    handleSE(){
      const storage = JSON.parse(localStorage.getItem("token"));
      this.$store.dispatch("fetchSE", {
        lbl: this.modal.se,
        token: storage.token
      }).then((res)=>{
        document.getElementById("lbl_result_se").innerHTML = res
      }).catch((err)=>{
        let responses = Object.assign({}, err.response);
        document.getElementById("lbl_result_se").innerHTML = responses.data.error
      })
    },
    viewNDA(){
      const storage = JSON.parse(localStorage.getItem("token"));
      this.loading.viewNDA = true
      axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/nda_document",
          auth: {
            username: this.activeUser.data.tlc,
            password: this.activeUser.data.password
          },
          responseType: 'arraybuffer',
          headers: {
            token: storage.token,
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
          },
        })
        .then((response) => {
          // console.log(response)
          const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/pdf' }));
          window.open(url, '_blank');

          var anchor = document.createElement('a');
          anchor.href = url;
          if (newTab) {
              anchor.target = '_blank';
          }
          anchor.click();

          this.loading.viewNDA = false
          // untuk download
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', 'file.pdf'); //or any other extension
          // document.body.appendChild(link);
          // link.click();
        })
        .catch(err => {
          this.loading.viewNDA = false
          if (err.response.data.message === false) {
            this.$notify.error({
              title: "Error",
              message: err.response.data.message
            });
          } else {
            let responses = Object.assign({}, err.response);
            this.$notify.error({
              title: "Error",
              message: responses
            });
          }
        });
    },
    emitRC(val){
      this.dataRCForm.data = val
    },
    emitCloseRC(){
      this.visibleRCForm = false
    },
    emitGetRC(){
      this.getRCList()
    }
  },
  mounted() {
    Event.$on("emitRC", this.emitRC);
    Event.$on("emitCloseRC", this.emitCloseRC);
    Event.$on("emitGetRC", this.emitGetRC);

    this.startAnimation();
    this.$store.dispatch("FetchSimfoniNotif");
    this.$store.dispatch("FetchHarmoniNotif");
    this.$store.dispatch("FetchKanalaNotif");
    this.$store.dispatch("FetchCommDashNotif");
    this.$store.dispatch("fetchAppsList");
    this.$store.dispatch("FetchCuentaNotif");

    this.socketListener("simfoniConnected", (user) => {
      this.$store.dispatch("RECEIVE_USERS", user);
    });
    this.socketListener("harmoniConnected", (user) => {
      this.$store.dispatch("RECEIVE_USERS", user);
    });
    this.socketListener("kanalaConnected", (user) => {
      this.$store.dispatch("RECEIVE_USERS", user);
    });
    this.socketListener("commDashConnected", (user) => {
      this.$store.dispatch("RECEIVE_USERS", user);
    });
    this.socketListener("notifHrm", (msg) => {
      this.$store.dispatch("RECEIVE_PRIVATE", msg);
    });
    this.socketListener("notifSim", (msg) => {
      this.$store.dispatch("RECEIVE_PRIVATE", msg);
    });
    this.socketListener("notifKnl", (msg) => {
      this.$store.dispatch("RECEIVE_PRIVATE", msg);
    });
    this.socketListener("messageResponse", (msg) => {
      this.$store.dispatch("FetchCommDashNotif");
      this.$store.dispatch("RECEIVE_PRIVATE", {type:'das', message: "New Chat from Commisioner Dashboard!"});
    });
    this.socketListener("notifQnt", (msg) => {
      this.$store.dispatch("FetchCuentaNotif")
      this.$store.dispatch("RECEIVE_PRIVATE", msg);
    });

    this.sendSocketEvent();

    this.checkSessionSSO()

    this.StartGPS()

    this.getAttendance()

    this.getRCList()

    document.addEventListener('DOMContentLoaded', function () {
      // Make the DIV element draggable:      
      // dragElement(document.getElementById("hmoveable"));

      function dragElement(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(elmnt.id + "header")) {
            // if present, the header is where you move the DIV from:
          // document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
          document.getElementById(elmnt.id + "header").ontouchstart = dragMouseDown;
        } else {
          // otherwise, move the DIV from anywhere inside the DIV:
          elmnt.onmousedown = dragMouseDown;
          elmnt.ontouchstart = dragMouseDown;
        }

        function dragMouseDown(e) {
          // console.log("masuk", e)
          e = e || window.event;
          e.preventDefault();
          event.stopPropagation();
          // get the mouse cursor position at startup:
          pos3 = e.clientX;
          pos4 = e.clientY;
          document.onmouseup = closeDragElement;
          // call a function whenever the cursor moves:
          document.onmousemove = elementDrag;
          document.ontouchmove = elementDrag;
        }

        function elementDrag(e) {
          // console.log("onmove",e)
          e = e || window.event;
          e.preventDefault();
          event.stopPropagation();
          // calculate the new cursor position:
          pos1 = pos3 - e.touches[0].clientX;
          pos2 = pos4 - e.touches[0].clientY;
          pos3 = e.touches[0].clientX;
          pos4 = e.touches[0].clientY;
          // set the element's new position:
          elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
          elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
          // stop moving when mouse button is released:
          document.onmouseup = null;
          document.onmousemove = null;
        }
      }
    })
  },
  beforeDestroy() {
    Event.$off("emitRC", this.emitRC);
    Event.$off("emitCloseRC", this.emitCloseRC);
    Event.$off("emitGetRC", this.emitGetRC);
  },
};
</script>

<style lang="scss" scoped>
// Desktop style
.home {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  min-height: 60%;
  margin: 0 12%;
  z-index: 1;

  &.mobile {
    margin: 0 4%;
  }

  @media #{$mq-xlarge} {
    margin: 0 18%;
  }

  .header {
    min-height: 60px;
    border-bottom: 1px dashed white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid darken(white, 10);
  }

  .content {
    padding: $space * 2 0;
  }
}

.grid {
  &-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-gap: $space;
    grid-template-rows: repeat(6);
    padding: 0;
  }
}

.brand {
  height: 40px;

  &-card {
    height: 50px;
  }

  &-apps {
    height: 25px;
    margin-right: 1em;
  }
}

.card {
  display: flex;
  background-color: transparentize($color: white, $amount: 0.7);
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: $space;
  position: relative;
  border: 1px solid darken(white, 8);
  min-height: 150px;

  &:before {
    content: "";
    box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    filter: blur(10px);
  }

  .brand-card {
    margin-bottom: $space / 2;
    height: 60px;
  }

  .title {
    letter-spacing: 1px;
    text-align: center;
  }

  .text-ideapp {
    color: brown;
    font-weight: bold;
  }

  &:after {
    content: "";
    position: absolute;
    background-color: transparentize($color: $notif-color, $amount: 0.5);
    left: -1px;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 50%;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 100;
    opacity: 0;
    transition: 0.2s all ease-in-out;
  }

  &:hover {
    transition: 0.2s all ease-in-out;
    box-shadow: 0px 8px 10px 0px rgba(10, 31, 68, 0.03);
    cursor: pointer;
    transform: scale(1.04);
    background-color: white;

    &:after {
      opacity: 1;
    }
  }

  .notif {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0;
    border: unset;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    background-color: $notif-color;
    color: white;
  }

  @media screen and #{$mq-xlarge} {
    min-height: 180px;

    .brand-card {
      height: 90px;
    }
  }
}

.card-hidden {
  display: none;
}

.card-disabled {
  display: flex;
  background-color: transparentize($color: white, $amount: 0.7);
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: $space;
  position: relative;
  border: 1px solid darken(white, 8);
  min-height: 150px;
  cursor: no-drop;

  &:before {
    content: "";
    box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    filter: blur(2px) contrast(0.7);
  }

  .brand-card {
    margin-bottom: $space / 2;
    height: 60px;
    filter: grayscale(70%);
  }

  .title {
    letter-spacing: 1px;
    text-align: center;
  }

  .text-ideapp {
    color: brown;
    font-weight: bold;
  }

  &:after {
    content: "";
    position: absolute;
    background-color: transparentize($color: $notif-color, $amount: 0.5);
    left: -1px;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 50%;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 100;
    opacity: 0;
    transition: 0.2s all ease-in-out;
  }

  // &:hover {
  //   transition: 0.2s all ease-in-out;
  //   box-shadow: 0px 8px 10px 0px rgba(10, 31, 68, 0.03);
  //   cursor: pointer;
  //   transform: scale(1.04);
  //   background-color: white;

  //   &:after {
  //     opacity: 1;
  //   }
  // }

  .notif {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0;
    border: unset;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    background-color: $notif-color;
    color: white;
    filter: grayscale(70%);
  }

  @media screen and #{$mq-xlarge} {
    min-height: 180px;

    .brand-card {
      height: 90px;
    }
  }
}

.users {
  display: flex;
}

.menus {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  gap: $space;
  cursor: pointer;

  .el-avatar {
    margin-left: $space;
  }
}

.popover {
  &-desc {
    display: flex;
    flex-direction: row;
    gap: $space / 2;
  }

  &-list {
    display: flex;
    gap: $space;
    padding: 0;
    margin-top: $space / 2;
    margin-bottom: 0;

    li {
      padding: 0;
      list-style: none;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        bottom: -5px;
        left: 0;
        right: 0;
        background-color: orange;
        height: 2px;
        opacity: 0;
        transition: 0.2s all ease-in-out;
      }

      &:hover {
        cursor: pointer;
        color: $subtext-color;

        &:after {
          opacity: 1;
        }
      }
    }
  }

  &-listapps {
    display: flex;
    gap: $space;
    padding: 0;
    margin-top: $space / 2;
    margin-bottom: 0;

    li {
      padding-left: 10px;
      padding-right: 10px;
      list-style: none;
      position: relative;
      width: 100%;
      border-bottom: 0.05em solid rgba(0, 0, 0, 0.1);

      &:before {
      }

      &:after {
        content: "";
        position: absolute;
        //bottom: -5px;
        left: 0;
        right: 0;
        //background-color: orange;
        //height: 2px;
        //opacity: 0;
        transition: 0.3s all ease-in-out;
        font-size: 150%;
      }

      &:hover {
        cursor: pointer;
        color: $subtext-color;
        font-weight: bolder;
        background-color: rgba(255, 166, 0, 0.05);

        &:after {
          // opacity: 0.3;
          border-bottom: 2px solid rgba(255, 166, 0, 1);
        }
      }
    }

    .url-list {
      display: flex;
      align-items: center;
      width: 100%;
      // border: 2px dashed #f69c55;

      padding-bottom: 5px;
      padding-top: 5px;
    }
  }
}

// Mobile Style
.mobile {
  .home {
    margin: 0;
    overflow: auto;

    .header {
      padding: 0 $space * 2;
      background-color: $primary-color;
    }

    .content {
      padding: $space $space * 2;
      flex: 1;
      overflow: auto;
    }
  }

  .grid {
    &-row {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      grid-gap: $space;
      grid-template-rows: repeat(6);
    }
  }

  .brand {
    height: 30px;
  }

  .profile {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: $space * 2;

    &-photo {
      border-radius: $space;
      height: 100px;
      border: 2px solid white;
      background: linear-gradient(145deg, #ffffff, #e6e6e6);
      box-shadow: 8px 8px 16px #ebebeb, -8px -8px 16px #ffffff;
      margin-bottom: $space;
    }
  }

  .m-menu-padding {
    margin-left: 2em;
    margin-right: 2em;
  }
}

.b-moveable{
  border-radius: 50px;
  padding: 12px 12px;
  
  i{
    font-size: xx-large;
  }
}

.i-moveable{
  color: #666;
}

#hmoveable {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  // top: 60px;
  //position: absolute;
  z-index: 9;
  background-color: #f1f1f1;
  // border: 1px solid #d3d3d3;
  text-align: center;

  .btn-tag {
    text-align: center;
    width: 100%;
    background: none!important;
    border-color: #ffffff00;
    font-size: medium;
    padding: 0px!important;
  }
}

#bodymoveable {
  display:flex;
  align-items: center;
  padding: 10px;
  cursor: move;
  z-index: 10;
  // background-color: #2196F3;
  color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.mobile{
  .grid-row{
    padding: 0 0 100px 0!important;
  }
}

</style>
